export default __webpack_public_path__ + "static/media/success.1274bfb2.svg";